// extracted by mini-css-extract-plugin
module.exports = {"header":"QSRSocialLandingFilterArea_header__A04z1","sortingButton":"QSRSocialLandingFilterArea_sortingButton__WYl6e","searchArea":"QSRSocialLandingFilterArea_searchArea__vhkWi"};